jQuery(function ($) {
  $(".btn-export-result").on("click", function (e) {
    e.preventDefault();
    const trigger = $(this);

    // target table should NOT be for summary table
    const targetTable = $(trigger.data("table"));
    const form = $(trigger.data("form"));

    if (targetTable.length > 0) {
      const tableClone = $(targetTable).clone();

      // strip any tags in the cell and only keep the text content
      tableClone.find("tbody td").each(function () {
        const textContent = $(this).text();
        $(this).html(textContent);
      });

      tableClone.find("thead th:has(div)").each(function () {
        const divs = $(this).find("div");
        divs.each(function (index) {
          // Check if the current <div> is not the last one in the cell
          if (index < divs.length - 1) {
            // Add " > " to the current <div>
            $(this).append(" > ");
          }
        });
      });

      tableClone.removeAttr("class").removeAttr("style").removeAttr("id");
      tableClone.find("tr, td, th").removeAttr("class").removeAttr("style");

      // Get the entire DOM element as a string
      const tableString = $(tableClone).prop("outerHTML");
      // .replace(/\s+/g, "");
      // .replace(/>\s+</g, "><");

      // console.log(
      //   "%c tableString ",
      //   "background: #4299E1; color: #fff",
      //   tableString
      // );

      form.find("textarea").val(tableString);

      form.find("button").trigger("click");
    }
  });
});
